import { IHistoriaEstadoEquipoRequest } from "../../Interfaces/auxiliar/IReporte";
import { fetchListVerificacion } from "../http-common";

const reporte = "Reporte";

const ReporteHistoricoEstadoEquipo = (request: IHistoriaEstadoEquipoRequest) => {
    return fetchListVerificacion.post(`${reporte}/HistoricoEstadoEquipo`, request);
};

const ReporteExcelHistoricoEstadoEquipo = (request: IHistoriaEstadoEquipoRequest) => {
    return fetchListVerificacion.post(`${reporte}/HistoricoEstadoEquipoExcel`, request, {
        responseType: "blob"
        /* params: Object.entries(request)
            .filter(([_, value]) => value !== "")
            .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {}) */
    })
}

export const ReporteService = {
    ReporteHistoricoEstadoEquipo,
    ReporteExcelHistoricoEstadoEquipo
}